// TODO: Move this to database and have it retrieved using an API as part of the frontend config
export const partners = {
  BAIRD_AND_WARNER: '660ff06fcd5f6a47996d8c76',
  BARRON_TEAM: '65d5c90054c0e5b0e6091f68',
  JMG: '661d7b9c42a90944d8fdc464',
  KEYES: '669a55c894721303b632d1d5',
  MAXHOME: '66e1c7916465b9a80254b24c', // Not in use as of now
};
